import { UltrabufEntries } from '@tencent/slide-sdk-pb-model/src/ultrabuf-mini/ultrabuf.types';
import { Base64String } from '../utils/base64-utils';
import { SlideCodec } from './slide-codec';
import type { ITransformRequest, ITransformResponse } from '@tencent/slide-sdk-pb-model';

export class TransformRequestData {
    public static fromBufferOrBase64(buffer: Uint8Array | string) {
        const data: ITransformRequest = SlideCodec.codec.decode<any>(buffer, UltrabufEntries.TransformRequest);
        return new TransformRequestData(data);
    }

    private data: ITransformRequest;

    public constructor(data: ITransformRequest) {
        this.data = data;
    }

    public toBase64String(): string {
        const buf: Uint8Array = SlideCodec.codec.encode<any>(this.data, UltrabufEntries.TransformRequest);
        return Base64String.fromUint8Array(buf);
    }

    public getTransformRequestData() {
        return this.data;
    }
}

export class TransformResponseData {
    public static fromBufferOrBase64(buffer: Uint8Array | string) {
        const data: ITransformResponse = SlideCodec.codec.decode<any>(buffer, UltrabufEntries.TransformResponse);
        return new TransformResponseData(data);
    }

    private data: ITransformResponse;

    public constructor(data: ITransformResponse) {
        this.data = data;
    }

    public toBase64String(): string {
        const buf: Uint8Array = SlideCodec.codec.encode<any>(this.data, UltrabufEntries.TransformResponse);
        return Base64String.fromUint8Array(buf);
    }

    public getTransformResponseData() {
        return this.data;
    }
}
